import React from 'react';

import { getTranslateByKey } from '@/main/services/utils';
import { useNavigate } from 'react-router-dom';

import Button from '@/main/components/shared/button/button';
import SupervisorBodyShopGrid from '@/main/components/shared/supervisorBodyshop/supervisorBodyshopGrid/supervisorBodyshopGrid';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

import * as S from '../styles';
interface ITabSettings {
  guidCompany: string;
}

export default function TabSupervisorSettings({ guidCompany }: ITabSettings) {
  const navigate = useNavigate();

  function handleBack() {
    navigate(-1);
  }

  return (
    <S.Container>
      <SupervisorBodyShopGrid guidCompany={guidCompany} />

      <S.FooterButtons>
        <SecondaryButton
          type="button"
          onClick={handleBack}
          id="id-supervisorClaimSettings-button-back">
          {getTranslateByKey('information.back')}
        </SecondaryButton>
        <Button
          id="id-supervisorClaimSettings-button-save"
          type="submit"
          disabled={true}>
          {getTranslateByKey('information.save')}
        </Button>
      </S.FooterButtons>
    </S.Container>
  );
}
